export default __webpack_public_path__ + "static/media/homeHeaderPolygonRight.3f613e2a.svg";